import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateGallery = () => {
  const token = useAuthToken();

  const createGallery = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/image", credentials, token);
  };

  return createGallery;
};

export const useGetGallery = () => {
  const token = useAuthToken();

  const getGallery = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/image/folder", null, token);
  };

  return getGallery;
};

export const useDeleteImage = () => {
  const token = useAuthToken();

  const deleteImage = async (filename) => {
    if (!filename) {
      throw new Error("Filename is required to delete an image");
    }

    return apiRequest(
      "delete",
      `/api/image/uplfolderoad/${filename}`,
      null,
      token
    );
  };

  return deleteImage;
};
